
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import ZeegBookingButton from '@/components/booking/ZeegBookingButton';

const BookingCTASection = () => {
  return (
    <section className="section-spacing bg-gradient-to-br from-joerg-50 to-joerg-100 text-joerg-900">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto text-left">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8 text-balance leading-tight tracking-tight text-joerg-800 animate-fade-in">
            Kostenfreies Erstgespräch vereinbaren
          </h2>
          
          <p className="text-lg mb-10 max-w-2xl text-pretty leading-relaxed text-joerg-700 opacity-90 animate-fade-in" style={{ animationDelay: '200ms' }}>
            Im persönlichen 30-minütigen Gespräch identifizieren wir gemeinsam 
            Ihre individuellen Ziele. Kein Verkaufsdruck, sondern eine partnerschaftliche 
            Bestandsaufnahme – ganz unverbindlich und ohne Risiko.
          </p>
          
          <div className="flex flex-col items-start justify-start gap-8">
            <ZeegBookingButton 
              text="30 Min Erstgespräch buchen" 
              variant="default" 
              size="lg" 
              className="bg-primary/90 text-white hover:bg-primary rounded-full py-6 px-8 text-lg font-semibold shadow-xl transition-all duration-300 hover:scale-105 flex items-center gap-3 max-w-md w-full justify-center group"
            />
            
            <Link 
              to="/kontakt" 
              className="flex items-center text-joerg-700 hover:text-joerg-900 transition-colors font-medium group"
            >
              Mehr Informationen zum Erstgespräch
              <ArrowRight className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingCTASection;
